import { ApiResourceBaseClass as c } from "./baseApiCalls.js";
const e = "interaction_tags";
class p extends c {
  /**
   * Searches for interaction tags.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/interaction_tags`
   *
   * @param {string} label
   * @param {number} page
   * @param {number} perPage
   */
  async getInteractionTags(t = "", a = 1, s) {
    const n = t ? { label: t } : {};
    n.page = a, s && (n.per_page = s);
    const { data: r } = await this.get(e, n);
    return r;
  }
  /**
   * Creates an interaction tag.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/interaction_tags`
   *
   * @param {Pick<InteractionTagType, 'label'>} payload
   */
  async create(t) {
    const { data: a } = await this.post(e, t);
    return a;
  }
  /**
   * Updates an interaction tag.
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/interaction_tags/:id`
   *
   * @param {number} tagId
   * @param {InteractionTagUpdatePayload} payload
   */
  async update(t, a) {
    const { data: s } = await this.put(`${e}/${t}`, a);
    return s;
  }
  /**
   * Deletes an interaction tag
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/interaction_tags/:id`
   *
   * @param {number} tagId
   */
  async deleteTag(t) {
    const { data: a } = await this.delete(`${e}/${t}`);
    return a;
  }
}
export {
  p as InteractionTag
};
